import React from 'react';
import { IconButtonProps } from 'components/IconButton';
import * as S from './styles';

export interface DialogCloseButtonProps
  extends Omit<IconButtonProps, 'as' | 'variant' | 'color'> {}

const DialogCloseButton: React.FC<DialogCloseButtonProps> = (props) => {
  const { 'aria-label': ariaLabel = 'close dialog' } = props;

  return (
    <S.Root {...props} aria-label={ariaLabel}>
      <S.Icon />
    </S.Root>
  );
};

export default DialogCloseButton;
